import React, { createContext, useState, useContext } from 'react';

// Create Context
const ChatInputContext = createContext();

// Context Provider Component
export const ChatInputProvider = ({ children }) => {
    const [inputValue, setInputValue] = useState('');

    return (
        <ChatInputContext.Provider value={{ inputValue, setInputValue }}>
            {children}
        </ChatInputContext.Provider>
    );
};

// Custom hook to use the chatInput context
export const useInputValue = () => useContext(ChatInputContext);